import { Row } from 'antd'
import React from 'react'

function RowStat({ children, style }) {
  return (
    <Row gutter={24} style={{ ...style, ...{ marginTop: 40 } }}>
      {children}
    </Row>
  )
}

export default RowStat
